// src/emailConfig.js

export const EMAILJS_CONFIG = {
    SERVICE_ID: 'service_zjfq7lj',
    PUBLIC_KEY: 'H4Wb4u1jkKbilPMFU',

    // ID reali forniti dai tuoi template creati su EmailJS
    TEMPLATE_NEW_BOOKING: 'template_llsrfua', // <-- Template ADMIN
    TEMPLATE_STATUS_UPDATE: 'template_3chyzlj', // <-- Template UTENTE

    ADMIN_EMAIL: 'prenotazioni@donmilanibagheria.it'
};
